// extracted by mini-css-extract-plugin
export default {"wrap":"SearchBar_wrap__9cG3n","input":"SearchBar_input__Mrdc4","icon":"SearchBar_icon__Yp4RJ","clear":"SearchBar_clear__JoPih"};